import { render, staticRenderFns } from "./NoveltySection.vue?vue&type=template&id=6fee3140&scoped=true&"
import script from "./NoveltySection.vue?vue&type=script&lang=ts&"
export * from "./NoveltySection.vue?vue&type=script&lang=ts&"
import style0 from "./NoveltySection.vue?vue&type=style&index=0&id=6fee3140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fee3140",
  null
  
)

export default component.exports